import React, {Component} from 'react';
import BigCalendar from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import Dimensions from 'react-dimensions'
import Breakpoints from '../../utils/breakpoints'
import CustomToolbar from './CustomToolbar'

import localizer from 'react-big-calendar/lib/localizers/moment';

class TimeSlotSelector extends Component {

  constructor(props) {
    super(props);
    moment.locale(this.props.language);
    localizer(moment);
    this.valueSelected = this.valueSelected.bind(this);
  }

  valueSelected(selected) {
    this.props.updateState("time_slot", selected);
  }

  render() {
    const isDesktop = this.props.containerWidth > Breakpoints.mobileScreenWidth;
    const view = isDesktop ? "week" : "day";
    const allowedViews = isDesktop ? ['week'] : ['day'];
    const calendarDefaultStartDate = this.props.availableTimes.length > 0 ? this.props.availableTimes[0].start : new Date();
    const userSelectedDate = this.props.date;
    const timeRangeFormat = ({start, end}, culture, local) => local.format(start, 'LT', culture) + ' — ' + local.format(end, 'LT', culture);

    const calendarDate = userSelectedDate === undefined ? calendarDefaultStartDate : userSelectedDate;

    const formats = {
      dayFormat: 'D.M dddd',
      eventTimeRangeFormat: timeRangeFormat
    };
    return (
      this.props.isLoading
        ? <span/>
        : <BigCalendar
        events={this.props.availableTimes}
        defaultView={view}
        view={view}
        views={allowedViews}
        min={moment(8, "HH").toDate()}
        max={moment(20, "HH").toDate()}
        formats={formats}
        date={calendarDate}
        onSelectEvent={this.valueSelected}
        onNavigate={this.props.onDateChange}
        components={{
          toolbar: CustomToolbar
        }}
        onView={(event) => {
        }}/> //BigCalendar issues warning without this
    );
  }
}
export default Dimensions()(TimeSlotSelector)



// WEBPACK FOOTER //
// ../components/booking/TimeslotSelector.js